import React, { FunctionComponent, useRef } from "react"

import Tooltip from "components/Tooltip/Tooltip"
import { Clamp } from "@/types"
import useClamped from "./useClamped"

interface IClampedTooltipProps {
    originalText?: string
    clamp?: Clamp
}

const ClampedTooltip: FunctionComponent<React.PropsWithChildren<IClampedTooltipProps>> = ({
    originalText,
    clamp,
    children
}) => {
    const textRef = useRef<HTMLDivElement>(null)
    const { isClamped } = useClamped({
        textRef,
        children,
    })

    const childrenWithProps = React.Children.map(children, child => {
        // checking isValidElement is the safe way and avoids a typescript error too
        if (React.isValidElement(child)) {
            return React.cloneElement<any>(child, {
                ref: (textRef as any),
                clamp,
            })
        }
        return <div ref={textRef}>{child}</div>
    })

    return (
        <Tooltip
            trigger="hover"
            content={isClamped ? originalText : undefined}
            disabled={!isClamped}>
            {childrenWithProps}
        </Tooltip>
    )
}

export default ClampedTooltip
